import React, { useState } from 'react';
import generateInvoice from './generateInvoice';

function InvoiceForm() {
  const getGuyanaDate = () => {
    const date = new Date().toLocaleString('en-US', {
      timeZone: 'America/Guyana',
    });
    const parsed = new Date(date);
    return parsed.toISOString().split('T')[0]; // format: YYYY-MM-DD
  };
  
  const [invoiceData, setInvoiceData] = useState({
    invoiceNo: '',
    invoiceDate: getGuyanaDate(), // ✅ default date = today in Guyana
    customerName: '',
    customerAddress: '',
    customerContact: '',
    items: [{ description: '', quantity: '', price: '' }],
    notes: '',
    discount: '',   // as a percentage or flat
    tax: ''       // as a percentage or flat

  });
  

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    if (name === 'description' || name === 'quantity' || name === 'price') {
      const updatedItems = [...invoiceData.items];
      updatedItems[index][name] = name === 'quantity' || name === 'price' ? value : value;
      setInvoiceData({ ...invoiceData, items: updatedItems });
    } else {
      setInvoiceData({ ...invoiceData, [name]: value });
    }
  };

  const addItem = () => {
    setInvoiceData({
      ...invoiceData,
      items: [...invoiceData.items, { description: '', quantity: '', price: '' }],
    });
  };

  const removeItem = (index) => {
    if (invoiceData.items.length === 1) return; // prevent deleting last item
    const updatedItems = invoiceData.items.filter((_, i) => i !== index);
    setInvoiceData({ ...invoiceData, items: updatedItems });
  };

  const handleGenerate = () => {
    // Convert empty values to numbers for safety
    const cleanedItems = invoiceData.items.map(item => ({
      ...item,
      quantity: Number(item.quantity) || 0,
      price: Number(item.price) || 0
    }));
    generateInvoice({ ...invoiceData, items: cleanedItems });
  };

  return (
    <div>
<div className="form-group-column">
  <label>Invoice No:</label>
  <input type="text" name="invoiceNo" value={invoiceData.invoiceNo} onChange={handleChange} />

  <label>Invoice Date:</label>
  <input type="date" name="invoiceDate" value={invoiceData.invoiceDate} onChange={handleChange} />

  <label>Customer Name:</label>
  <input type="text" name="customerName" value={invoiceData.customerName} onChange={handleChange} />

  <label>Customer Address:</label>
  <input type="text" name="customerAddress" value={invoiceData.customerAddress || ''} onChange={handleChange} />

  <label>Contact Number:</label>
  <input type="text" name="customerContact" value={invoiceData.customerContact || ''} onChange={handleChange} />
  <label>Discount (%):</label>
<input
  type="number"
  name="discount"
  value={invoiceData.discount}
  onChange={handleChange}
/>

<label>Tax (%):</label>
<input
  type="number"
  name="tax"
  value={invoiceData.tax}
  onChange={handleChange}
/>

</div>


      <h3>Invoice Items</h3>
      {invoiceData.items.map((item, index) => (
        <div key={index} className="form-row">
          <input
            type="text"
            name="description"
            placeholder="Description"
            value={item.description}
            onChange={(e) => handleChange(e, index)}
          />
          <input
            type="number"
            name="quantity"
            placeholder="Qty"
            min="1"
            value={item.quantity}
            onChange={(e) => handleChange(e, index)}
          />
          <input
            type="number"
            name="price"
            placeholder="Price"
            min="0"
            step="0.01"
            value={item.price}
            onChange={(e) => handleChange(e, index)}
          />
          <button
            type="button"
            title="Remove this item"
            onClick={() => removeItem(index)}
          >
            Remove
          </button>
        </div>
      ))}

      <button type="button" onClick={addItem}>+ Add Item</button>

      <div className="form-group">
        <label>Notes:</label>
        <textarea name="notes" value={invoiceData.notes} onChange={handleChange} rows="3" />
      </div>

      <button className="generate-btn" onClick={handleGenerate}>Generate PDF</button>
    </div>
  );
}

export default InvoiceForm;
